import React, {Component} from 'react'
import Background from 'shared/background'
import Link from 'shared/link'
import parse from 'html-react-parser'
import style from './list.module.scss'

class LocationList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			locations: this.props.data,
		}
	}
	componentDidMount() {
		if (this.props.department && Object.keys(this.props.department)) {
			if (this.props.department.uri == "/departments/heritage-womens-center/") {
				if (this.state.locations.length) {
					this.state.locations.forEach((location, index) => {
						if(Object.keys(location.hours).length > 0) {
							location.hours = {};
						}
					});
				}
			}
		}
	}
	render() {
		return (
			<div className={style.container}>
				<div className={["grid-container"].join(' ')}>
					<div className="grid-x">
						<div className={style.header}>
							<h3>{this.props.title ? this.props.title : 'Locations'}</h3>
							{/*<p><Link to="/locations/">VIEW ALL LOCATIONS</Link></p>*/}
						</div>
					</div>
					<div className="grid-x medium-up-2">
						{this.state.locations.map((location, index) => (
							<div key={index} className={[style.location, "cell"].join(' ')}>
								<Link to={location.uri}>
									<div className={style.card}>
										<div className={style.photoFrame}>
											<div className={[style.image, !Object.keys(location.hours).length > 0 ? style.noHours : ''].join(' ')}>
												<Background className={style.photo} remoteImage={(location.photo) ? false : true} image={(location.photo) ? location.photo : `https://maps.googleapis.com/maps/api/staticmap?markers=${location.address.replace(/ /g,"+")}+${location.city.replace(/ /g,"+")},${location.state}+${location.zip}&zoom=16&size=300x400&key=${process.env.GOOGLE_MAPS_API_KEY}`}>
													{location.photo && <div className={style.map}>
														{/*<Background className={style.mapFPO} image="/userfiles/map-fpo.png" />*/}
														<Background className={style.mapFPO} remoteImage={true} image={`https://maps.googleapis.com/maps/api/staticmap?markers=size:small|${location.address.replace(/ /g,"+")}+${location.city.replace(/ /g,"+")},${location.state}+${location.zip}&zoom=15&size=100x100&key=${process.env.GOOGLE_MAPS_API_KEY}`} />
													</div>}
												</Background>
											</div>
										</div>
										<div className={style.content}>
											<div className={[style.locationInfo, !Object.keys(location.hours).length > 0 ? style.noHours : ''].join(' ')}>
												<div className={style.name}>{location.name}</div>
												<p className={style.locAddress}>{location.address}<br />{location.floor ? parse(`${location.floor}<br />`) : ''}{location.city}, {location.state} {location.zip}</p>
											</div>
											{Object.keys(location.hours).length > 0 && <div className={[style.hours, 'cell medium-8 large-7'].join(' ')}>
												<p className={style.hoursTitle}>Hours:</p>
												<div className={style.hoursList}>
													{Object.keys(location.hours).map((key, index) => (
														<p key={index} className={style.dayHours}>{key}: {location.hours[key]}</p>
													))}
												</div>
											</div>}
										</div>
									</div>
								</Link>
							</div>
						))}
					</div>
				</div>
			</div>
		)
	}
}

export default LocationList;